export const themes = {
  blue: {
    name: 'Blue Theme',
    colors: {
      'app-bg': 'rgb(255, 255, 255)',
      'app-sidebar': 'rgb(245, 246, 247)',
      'app-hover': 'rgba(31, 35, 41, 0.06)',
      'app-active': '#BAD5EB',
      'app-border': 'rgb(222, 224, 227)',
      'citation-bg': '#0000000C',
      'brand-50': '#E6F2FF',
      'brand-100': '#006cec19',
      'brand-200': '#99CCFF',
      'brand-300': '#66B3FF',
      'brand-400': '#4DA3FF',
      'brand-500': '#006CEC',
      'brand-600': '#006CEC',
      'brand-700': '#00418C',
      'brand-800': '#002C5C',
      'brand-900': '#00172C',
    }
  },
  orange: {
    name: 'Orange Theme',
    colors: {
      'app-bg': '#F6F1EC',
      'app-sidebar': '#EFEAE7',
      'app-hover': '#EEE5D5',
      'app-active': '#E9D9BC',
      'app-border': '#DFD6CA',
      'citation-bg': '#0000000C',
      'brand-50': '#FFF4E6',
      'brand-100': '#FFE9CC',
      'brand-200': '#FFD699',
      'brand-300': '#FFC266',
      'brand-400': '#FFAD4D',
      'brand-500': '#EC8000',
      'brand-600': '#C66A00',
      'brand-700': '#A05500',
      'brand-800': '#7A4000',
      'brand-900': '#542B00',
    }
  },
  white: {
    name: 'Nebula White',
    colors: {
      'app-bg': 'rgb(255, 255, 255)',
      'app-sidebar': 'rgb(245, 246, 247)',
      'app-hover': 'rgba(31, 35, 41, 0.06)',
      'app-active': '#E0E0E2',
      'app-border': 'rgb(222, 224, 227)',
      'citation-bg': '#0000000C',
      'brand-50': '#F5F5F5',
      'brand-100': '#ECECED',
      'brand-200': '#C5C5C7',
      'brand-300': '#A8A8AD',
      'brand-400': '#78787F',
      'brand-500': '#3C3C43',
      'brand-600': '#2E2E34',
      'brand-700': '#232328',
      'brand-800': '#1A1A1E',
      'brand-900': '#111114',
    }
  }
};

export const defaultTheme = 'white';
